import { useTranslation } from 'react-i18next'

export const useAccountNumberForLoanError = () => {
  const { t } = useTranslation()
  const getErrorDescription = (errorDescription: string) => {
    if (errorDescription === 'Úvěr nenalezen') {
      return t('ERRORS.LOAN_NOT_FOUND')
    }
    return t('ERRORS.GENERAL_ERROR')
  }

  return { getErrorDescription }
}
